



































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import MaterialPane from '@/components/material/material-pane.vue'
import { RequestPaging } from '@/utils/util'
import { apiMaterialLists, apiMaterialCategoryList, apiWarehouseList } from '@/api/material'

@Component({
  components: {
    MaterialPane
  }
})
export default class MaterialList extends Vue {
    queryObj: any = {
      keyword: '',
      category_id: '',
      material_type: '',
      inventory_status: '',
      brand: '',
      warehouse_id: ''
    }

    categoryList: any[] = []
    warehouseList: any[] = []
    materialTypeList: any[] = [
      { value: '1', label: '普通物料' },
      { value: '2', label: '批次管理' },
      { value: '3', label: '序列号管理' }
    ]

    pager = new RequestPaging()
    apiMaterialLists = apiMaterialLists

    getList (page?: number): void {
      page && (this.pager.page = page)
      this.pager
        .request({
          callback: apiMaterialLists,
          params: {
            ...this.queryObj
          }
        })
    }

    handleReset () {
      this.queryObj = {
        keyword: '',
        category_id: '',
        material_type: '',
        inventory_status: '',
        brand: '',
        warehouse_id: ''
      }
      this.getList(1)
    }

    handleAdd () {
      this.$router.push('/material/add')
    }

    handleExport () {
      // 导出功能实现
      console.log('导出数据')
    }

    handleImport () {
      // 跳转到批量导入页面
      this.$router.push('/material/inventory/import')
    }

    getMaterialCategoryList () {
      apiMaterialCategoryList().then((res: any) => {
        this.categoryList = res.lists || []
      })
    }

    getWarehouseList () {
      apiWarehouseList().then((res: any) => {
        this.warehouseList = res.lists || []
      })
    }

    created () {
      this.getMaterialCategoryList()
      this.getWarehouseList()
      this.getList()
    }

    activated () {
      this.getList()
    }
}
